// extracted by mini-css-extract-plugin
export var bigLogo = "logo-module--big-logo--iBFNW";
export var black = "logo-module--black--+iu97";
export var logo = "logo-module--logo--wQr9y";
export var responsive = "logo-module--responsive--D5ylg";
export var sygnet = "logo-module--sygnet--LbGnD";
export var white = "logo-module--white--xV6rN";